export enum InputTypeEnum {
  text = 'text',
  number = 'number',
  password = 'password',
  date = 'date',
  month = 'month',
  time = 'time',
  datetime = 'datetime-local',
  color = 'color'
}
